import {Directive, Injectable, ElementRef, Renderer2,
    AfterContentChecked, OnInit, OnDestroy, Inject} from '@angular/core';
import {AbsTablesComponent} from './abs-tables.component';

@Directive({
    selector: '[abs-table-body]',
})
@Injectable()
export class TableBodyComponent implements AfterContentChecked , OnInit, OnDestroy {
     columnIndex;
     hiddenColumn;
     directiveRef = [];
     rowValues: any = [];
    constructor(
        @Inject(ElementRef) private element: ElementRef,
        @Inject(Renderer2) private renderer: Renderer2,
        @Inject(AbsTablesComponent) private absTableComponent: AbsTablesComponent,
    ) { }
    ngOnInit() {
        this.renderer.listen(window, 'resize', () => {
            this.hidingFn();
        });
    }
    ngAfterContentChecked() {
        this.hidingFn();
    }
    ngOnDestroy(){
        this.renderer.destroy();
    }
     hidingFn() {
        this.rowValues = [];
        this.hiddenColumn = this.absTableComponent.hiddenColumn;
        if(this.isHidden()){
            this.renderer.setAttribute(this.element.nativeElement,"hidden","true");
        }
        else{
            this.renderer.removeAttribute(this.element.nativeElement,"hidden");
        }
        for (let i = 0; i < this.directiveRef.length; i++) {
            if (this.directiveRef[i].childNodes[0] !== undefined) {
                if (this.directiveRef[i].childNodes[0].data !== '') {
                    this.setRowValues(this.directiveRef[i]);
                }
            }
        }
        this.absTableComponent.rowValue = this.rowValues;
    }
     setRowValues(rowValue) {
        this.rowValues.push(rowValue);
    }
     isHidden() {
        this.columnIndex = this.setIndex(this.element.nativeElement);
        return (this.absTableComponent.hiddenColumn.indexOf(this.columnIndex) > -1);
    }
     setIndex(headerScope) {
        this.directiveRef = this.element.nativeElement.parentElement.querySelectorAll('td');
        for (let i = 0; i < this.directiveRef.length; i++) {
            if (this.directiveRef[i].contains(headerScope)) {
                return i;
            }
        }

    }
}